var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.getStatusClasses},[(_vm.statusPrefix)?_c('span',[_vm._v("\n    "+_vm._s(_vm.statusPrefix)+"\n  ")]):_vm._e(),_vm._v("\n  "+_vm._s(_vm.getStatusName)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a47d14d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseStatusBadge.vue
// module id = 1237
// module chunks = 1